import React from 'react';
import * as ReactDOM from "react-dom";
import { BrowserRouter, Route } from 'react-router-dom';

import ForgotPassword from '../pages/ForgotPassword';
import Home from '../pages/Home';
import Login from '../pages/Login';
import Schedule from '../pages/Schedule';
import Skills from '../pages/Skills';
import Report from '../pages/Report';
import { PDFView } from '../pages/PDFView';

import { SkillsProvider } from '../hooks/skills';
import { ScheduleProvider } from '../hooks/schedules';
import { UserProvider } from '../hooks/user';

const Routes: React.FC = () => {
  return (
    <>
      <BrowserRouter>
        <Route exact path="/" component={Home} />
        <Route path="/forgotPassword" component={ForgotPassword} />
        <UserProvider>
          <Route path="/login" component={Login} />
          <ScheduleProvider>
            <SkillsProvider>
              <Route path="/skills" component={Skills} />
            </SkillsProvider>


            <Route path="/schedule" component={Schedule} />
            <Route path="/PDF" component={PDFView} />
            <Route path="/report" component={Report} />
          </ScheduleProvider>
        </UserProvider>
      </BrowserRouter>
    </>
  )
}

export default Routes;